import styled from '@emotion/styled';

export const HorizontalNavWrapper = styled.div`
  position: relative;
  /* z-index: -2; */
  width: 100%;
`;
